import React from 'react'
import Navbar from '../inc/Navbar'
import Project from './Project'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
function Projectpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
           <ScrollToTop smooth top="100" color="maroon"/>
         <div className="cctvfotageberhampore">
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Projects</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        <Project/>
        <br/>
    </div>
  )
}

export default Projectpage